import { render, staticRenderFns } from "./flats-find-num.vue?vue&type=template&id=58977f3b"
import script from "./flats-find-num.vue?vue&type=script&lang=js"
export * from "./flats-find-num.vue?vue&type=script&lang=js"
import style0 from "./flats-find-num.vue?vue&type=style&index=0&id=58977f3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports